import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ConfigurationProfilesAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    var message = {
      body: 'CONFIGURATION_PROFILE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    var message = {
      body: 'CONFIGURATION_PROFILE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DUPLICATE //
  duplicateSuccess() {
    var message = {
      body: 'CONFIGURATION_PROFILE_DUPLICATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  duplicateError() {
    var message = {
      body: 'CONFIGURATION_PROFILE_DUPLICATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    var message = {
      body: 'CONFIGURATION_PROFILE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    var message = {
      body: 'CONFIGURATION_PROFILE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE ACCOUNTS ASSIGNED //
  updateAccountsSuccess() {
    var message = {
      body: 'ACCOUNTS_ASSIGN_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateAccountsError() {
    var message = {
      body: 'ACCOUNTS_ASSIGN_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  removeSuccess() {
    var message = {
      body: 'CONFIGURATION_PROFILE_REMOVE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeError() {
    var message = {
      body: 'CONFIGURATION_PROFILE_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  removeUsedError() {
    var message = {
      body: 'CONFIGURATION_PROFILE_REMOVE_ERROR',
      details: 'USED_PROFILE'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.configuration-profiles')
  .service('configurationProfilesAlertsService', ConfigurationProfilesAlertsService);
